import type { ReactNode } from 'react';
import { EditorialArt, type ArtVariant } from './Art';
import { MicroLabel } from './Typography';

/**
 * Editorial entry composition (Editorial Brand System 2026) for sign-in screens that render inside the portal shell
 * (partner and staff surfaces). Parity with the standalone customer sign-in: fine grid field with restrained
 * off-canvas art, mono eyebrow, oversized headline with one serif pivot, and the form on white beside it. Below
 * 1200 px the hero stacks above the form and the art retreats to the top inline-end corner, so type never sits on a
 * disc. The hero headline is a paragraph: the page's single h1 stays in `children` (the form column).
 */
export function EntryLayout({ art, eyebrow, headline, pivot, note, testId, dir, lang, children }: {
  art: ArtVariant; eyebrow: ReactNode; headline: ReactNode; pivot: ReactNode; note?: ReactNode;
  testId?: string; dir?: 'ltr' | 'rtl'; lang?: string; children: ReactNode;
}) {
  return (
    <section className="qm-entry" data-testid={testId} dir={dir} lang={lang}>
      <div className="qm-entry__hero">
        <EditorialArt variant={art} />
        <div className="qm-entry__hero-text">
          <MicroLabel>{eyebrow}</MicroLabel>
          <p className="qm-entry__headline">{headline} <span className="qm-pivot">{pivot}</span></p>
        </div>
        {note ? <MicroLabel className="qm-entry__note">{note}</MicroLabel> : null}
      </div>
      <div className="qm-entry__main">{children}</div>
    </section>
  );
}
